enum UserType {
  VRS = 'VRS',
  VRI = 'VRI',
  BLANK = '',
}

export default UserType;
